import { isNewConnectionRoute } from '../common/environment';
import { LayoutPropTypes } from '../components/layout/LayoutPropTypes';

export const ROUTE_CONSTANTS: Record<string, LayoutPropTypes> = {
   corporate: {
      path: getBasePath('email'),
      currPage: 'COIP_INGRESS_LANDING_PAGE',
      showHeader: true,
      showFooter: true,
   },
   postpaid: {
      path: getBasePath('add_details'),
      currPage: 'common_add_details_page',
      showHeader: true,
      showFooter: true,
   },
   newAndNewBundlingAddress: {
      path: getBasePath('bundling_address'),
      currPage: 'BUNDLING_ADDRESS_NP2P',
      showHeader: true,
   },
   p2pActivationPage: {
      path: getBasePath('benefits'),
      currPage: 'P2P_Activation_Page',
      showHeader: true,
   },
   postpaid_widget: {
      path: getBasePath('add-details-widget'),
      currPage: 'common_postpaid_add_details_widget',
      showHeader: false,
      showFooter: false,
   },
   home: {
      path: getBasePath(),
      currPage: 'common_add_details_page',
      showHeader: true,
      showFooter: true,
   },
   AcquisitionPlanListing: {
      path: getBasePath('acquisition_listing_page'),
      currPage: 'Acquisition_Plan_Listing_Page',
      showHeader: false,
      showFooter: false,
   },
   addDetailsChild: {
      path: getBasePath('add_details_child'),
      currPage: 'FAMILY_ADD_DETAILS_CHILD_PAGE',
      showHeader: true,
      showFooter: true,
   },
   OrderSummaryBundling: {
      path: getBasePath('order-summary-bundling'),
      currPage: 'family_order_summary_bundling_parent',
      showHeader: true,
      showFooter: false,
   },
   addConnectionPage: {
      path: getBasePath('add-connection'),
      currPage: 'FAMILY_WEB_ADD_FREE_CONNECTION',
      showFooter: true,
      showHeader: true,
   },
   addConnectionV2Page: {
      path: getBasePath('add-connection-new'),
      currPage: 'ADD_CONNECTION_V2',
      showFooter: true,
      showHeader: true,
   },
   paymentLoaderPage: {
      path: getBasePath('payment-loader'),
      currPage: 'FAMILY_DETAILS_CHILD_PAYMENT_LOADER_PAGE',
      showFooter: true,
      showHeader: true,
   },
   OrderSummaryChild: {
      path: getBasePath('child-order-summary'),
      currPage: 'FAMILY_ORDER_SUMMARY_CHILD_PAGE',
      showHeader: true,
      showFooter: false,
   },
   OrderSummaryChildNew: {
      path: getBasePath('child-order-summary-new'),
      currPage: 'FAMILY_ORDER_SUMMARY_CHILD_REVAMP_PAGE',
      showHeader: true,
      showFooter: false,
   },
   AddDetailsChildNew: {
      path: getBasePath('add-child-details-new'),
      currPage: 'FAMILY_ADD_DETAILS_CHILD_REVAMP',
      showHeader: true,
      showFooter: false,
   },
   ThanksAddChildNew: {
      path: getBasePath('thanks-add-child-details-new'),
      currPage: 'FAMILY_ADD_DETAILS_CHILD_THANKS_PAGE',
      showHeader: true,
      showFooter: false,
   },
   OrderSummaryParent: {
      path: getBasePath('order-summary'),
      currPage: 'FAMILY_ORDER_SUMMARY_PARENT_PAGE',
      showHeader: true,
      showFooter: false,
   },
   thankYouPageParent: {
      path: getBasePath('thank-you'),
      currPage: 'FAMILY_THANKYOU_SIT',
      showHeader: true,
   },
   thanks: {
      path: getBasePath('thanks'),
      currPage: 'acquisition_thanks_page',
      showHeader: true,
   },
   thanks_bundling: {
      path: getBasePath('thanks_bundling'),
      currPage: 'bundling_thanks_portfolio',
      showHeader: true,
   },
   paymentLoaderOtpShiftPage: {
      path: getBasePath('p2p-payment-loader'),
      currPage: 'COMMON_ADD_DETAILS_PAYMENT_LOADER_PAGE',
      showFooter: true,
      showHeader: true,
   },
   otpShiftLoaderPage: {
      path: getBasePath('p2p-loader'),
      currPage: 'OTP_SHIFT_LOADER_PAGE',
      showFooter: true,
      showHeader: true,
   },
   otpShiftOrderSummaryPage: {
      path: getBasePath('parent-order-summary-new'),
      currPage: 'P2P_OTP_SHIFT_ORDER_SUMMARY',
      showFooter: true,
      showHeader: true,
   },
   postpaidCategoriesPage: {
      path: '/discover',
      currPage: 'Category_Pages',
      showHeader: true,
      showFooter: false,  
   },
};

export const PAGESPACE_PAGES = Array.from(
   new Set(Object.values(ROUTE_CONSTANTS).map((route) => route.currPage))
);

function getBasePath(path = '') {
   return isNewConnectionRoute() ? `:intent?/${path}` : `/${path}`;
}
